<app-sidebar>
  <div class="address-book-page">
    <div class="page-header">
      <h1>Address Book</h1>
      <p>Latest single and multi searches in one place</p>
    </div>

    <div class="search-row">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search name or ID number</mat-label>
        <input
          matInput
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Start typing to search...">
        <button
          mat-icon-button
          matSuffix
          type="button"
          *ngIf="searchTerm"
          (click)="onSearchChange('')"
          matTooltip="Clear search">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="address-book-loading-state" *ngIf="isLoadingAddressBook">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading address book...</p>
    </div>

    <div class="address-book-empty-state" *ngIf="!isLoadingAddressBook && !consentRequired && !hasEntries">
      <mat-icon>contacts</mat-icon>
      <p>No contact found.</p>
    </div>

    <div class="address-book-card" *ngIf="!isLoadingAddressBook && hasEntries">
      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let entry">{{ formatName(entry) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="idNumber">
          <mat-header-cell *matHeaderCellDef>ID Number</mat-header-cell>
          <mat-cell *matCellDef="let entry">
            <span class="masked-id">{{ entry.idNumber || '—' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastLookedUpAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Last Looked Up</mat-header-cell>
          <mat-cell *matCellDef="let entry">{{ formatDate(entry.lastLookedUpAt) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="availability">
          <mat-header-cell *matHeaderCellDef>Availability</mat-header-cell>
          <mat-cell *matCellDef="let entry" [matTooltip]="getAvailabilityTooltip(entry)">
            <span class="availability-chip">
              <mat-icon [color]="getAvailabilityIconColor(entry)">{{ getAvailabilityIcon(entry) }}</mat-icon>
              {{ getAvailabilityText(entry) }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let entry">
            <div class="actions-cell">
              <span [matTooltip]="getActionTooltip(entry)">
                <button
                  mat-icon-button
                  color="primary"
                  (click)="viewData(entry)"
                  [disabled]="!canView(entry)">
                  <mat-icon>{{ getActionIcon(entry) }}</mat-icon>
                </button>
              </span>

              <span
                *ngIf="!isMultiSearch(entry)"
                [matTooltip]="getMarkDncTooltip(entry)">
                <button
                  mat-icon-button
                  type="button"
                  color="warn"
                  [disabled]="!canMarkDnc(entry) || isMarkDncLoading(entry)"
                  (click)="markAsDnc(entry)">
                  <mat-icon [class.spin-icon]="isMarkDncLoading(entry)">
                    {{ isMarkDncLoading(entry) ? 'autorenew' : 'phone_disabled' }}
                  </mat-icon>
                </button>
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="50"></mat-paginator>
    </div>
  </div>
</app-sidebar>
